import { render, staticRenderFns } from "./SkinRevealDialog.vue?vue&type=template&id=1a5927ba&scoped=true"
import script from "./SkinRevealDialog.vue?vue&type=script&lang=js"
export * from "./SkinRevealDialog.vue?vue&type=script&lang=js"
import style0 from "./SkinRevealDialog.vue?vue&type=style&index=0&id=1a5927ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5927ba",
  null
  
)

export default component.exports